import { BerthBoatAssignment } from '@shared/models/berth-boat-assignment';

interface WithBerthAssignments {
    berthAssignments?: BerthBoatAssignment[];
}

/**
 * Which bookings the contract's berths are taken from.
 *
 * A booking dictates its own berths - and it has to, because the boat nested in a booking is the
 * one from its berth assignments and carries no assignments of its own (#6958). Only outside a
 * booking does the boat's whole assignment history define what a contract may cover.
 */
export function resolveContractBerthAssignments(
    booking: WithBerthAssignments | null | undefined,
    boat: WithBerthAssignments | null | undefined,
): BerthBoatAssignment[] {

    if (booking) {
        return (booking.berthAssignments || []).filter(assignment => !assignment.deleted);
    }

    return boat?.berthAssignments || [];
}
